import { useQuery } from "react-query";
import { FinancialManagementService } from "../../../services/financialManagement/FinancialManagementService";

const fetchInvoiceDetails = async (row: any) => {
    const ClientId = row.clientId;
    const RpsId = row.rpsId;
    const SalesOrderId = row.salesOrderId;
    const service = new FinancialManagementService({});
    const response = await service.GetCompleteInvoiceDetails(ClientId, RpsId, SalesOrderId);

    return {
        NfSelected: row.nfseId,
        NFDetails: response,
        filteredNFDetailsItens: response?.itens || [],
        filteredNFNFLicensesItens: response?.licenses || []
    };
};

export function useInvoiceDetails(row: any) {
    return useQuery({
        queryKey: ["invoiceDetails", row?.clientId, row?.rpsId, row?.salesOrderId],
        queryFn: () => fetchInvoiceDetails(row),
        enabled: !!row?.clientId && !!row?.rpsId && !!row?.salesOrderId,
        staleTime: 1000 * 60 * 5,
    });
}